<template>
  <div class="loginBG" :style="setLoginImg">
    <div ref="container" class="container_lining" v-if="onload">
      <!-- <img :src="setLogoImg" alt="logo" class="logo" /> -->
      <span class="titleTOP">用户登录</span>
      <div class="divAccount">
        <img :src="path + '/common/account.png'" class="icon" />
        <input ref="username" type="text" value class="username" placeholder="请输入用户名" />
      </div>
      <div class="divMima">
        <img :src="path + '/common/password.png'" class="icon" />
        <input ref="password" type="password" value class="pwd" placeholder="请输入密码" />
      </div>

      <div class="drag" ref="dragDiv">
        <div class="drag_bg"></div>
        <div class="drag_text">{{confirmWords}}</div>
        <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
    </div>

      <div id="btn" class="btn" @click="login" />
      <Spin v-show="spinShow" fix>
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" fill="none" stroke-width="5" stroke-miterlimit="10" />
          </svg>
        </div>
      </Spin>
    </div>
  </div>
</template>

<script>
import { branch } from '@/constants/global';

export default {
  name: "Login",
  data() {
    return {
      path: "../src/assets/images/",
      spinShow: false,
      onload:true,

      beginClientX:0,           /*距离屏幕左端距离*/
      mouseMoveStata:false,     /*触发拖动状态  判断*/
      maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'拖动滑块验证',   /*滑块文字*/
      confirmSuccess:false,           /*验证成功判断*/
      captcha:'',
    };
  },
  computed: {
    setLoginImg() {
      return `background: url(/src/assets/images/${branch}/loginBg_BRAND_PIC.png) no-repeat center /100%;`;
    },
    setLogoImg() {
      return `/src/assets/images/${branch}/loginLogo_BRAND_PIC.png`;
    },
  },
  methods: {
    login() {
      let message = {};
      this.spinShow = true;
      const Version = window.ProjectConfig.Version;
      const randomKey = btoa(`${Math.random() * 10000000000}`).substring(0,5);
      const enableGateWay = window.ProjectConfig.enableGateWay;
      const pwdRegex = new RegExp('([0-9A-Za-z.*=])');

      if (this.$refs.username.value === "") {
        message = {
          title: "错误",
          content: "请输入用户名",
          onOk: () => {
            this.spinShow = false;
          }
        };
        this.$Modal.fcError(message);
      }else if(!this.captcha){
        message = {
          title:"错误",
          content:"请滑动验证!",
          onOk: () => {
            this.spinShow = false;
          }
        }
        this.$Modal.fcError(message);
      } else if (this.$refs.password.value === "") {
        message = {
          title: "错误",
          content: "请输入密码",
          onOk: () => {
            this.spinShow = false;
          }
        };
        this.$Modal.fcError(message);
      }else if(!pwdRegex.test(this.$refs.password.value)){
        message = {
          title: "错误",
          content: "密码中必须包含大小写字母、数字、特殊字符!",
          onOk: () => {
            this.spinShow = false;
          }
        };
        this.$Modal.fcError(message);
      } else if (
        this.$refs.username.value !== "" &&
        this.$refs.password.value !== ""
      ) {
            this.$network
              .post(
                enableGateWay ? `/${globalServiceId}/p/c/login` : "/p/c/login",
                this.$urlSearchParams({
                  username: this.$refs.username.value,
                  password: `${randomKey}${btoa(this.$refs.password.value)}`,
                  captcha: this.captcha,
                  encrypted:true,
                  rememberMe: false,
                  lang: "zh_CN"
                })
              )
              .then(r => {
                if (Version === "1.3") {
                  if (r.status === 200 && r.data.code === 1) {
                    // if (/^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+)$/.test(this.$refs.password.value)) {
                    //   sessionStorage.setItem("needModifyPassWord", true)
                    // } else {
                    //   sessionStorage.removeItem("needModifyPassWord")
                    // }
                    if (r.data.user.userenv.$PASSWORDRESET$ === 'Y') {
                      sessionStorage.setItem("needModifyPassWord", true)
                    } else {
                      sessionStorage.removeItem("needModifyPassWord")
                    }
                    // console.log('r :>> ', r.data.user.isAdmin);
                    localStorage.setItem('userName',r.data.user.name) //统一待办中使用，WelcomePage.vue
                    window.location.href = window.location.origin;
                  } else {
                    this.spinShow = false;
                    //初始化滑块
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
                    this.confirmSuccess = false;
                    this.confirmWords = "拖动滑块验证"
                    this.mouseMoveStata = false
                    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
                    document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
                  }
                } else if (r.status === 200 && r.data.code === 0) {
                  window.location.href = window.location.origin;
                }
              });
      }
    },
    mousedownFn(e){
      console.log(e);
      if(!this.confirmSuccess){
        e.preventDefault && e.preventDefault();
        this.mouseMoveStata = true;
        this.beginClientX = e.clientX;
      }
    },
    successFunction(){
        this.confirmSuccess = true
        this.confirmWords = '验证通过';
        if(window.addEventListener){
            document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
            document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
        }else {
            document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
        }
        document.getElementsByClassName('drag_text')[0].style.color = '#fff'
        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
        const enableGateWay = window.ProjectConfig.enableGateWay;
        const globalServiceId = window.sessionStorage.getItem("serviceId");
        this.$network
          .post(
            enableGateWay
              ? `/${globalServiceId}/p/c/getCaptcha`
              : "/p/c/getCaptcha"
          ).then(res=>{
            this.captcha = res.data.captcha;
          })
    },                //验证成功函数
    mouseMoveFn(e){
        if(this.mouseMoveStata){
          console.log(e);
            let width = e.clientX - this.beginClientX;
            if(width>0 && width<=this.maxwidth){
                document.getElementsByClassName('handler')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
            }else if(width>this.maxwidth){
                this.successFunction();
            }
        }
    },                   //mousemove事件
    moseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.clientX - this.beginClientX;
        if(width<this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
    }
  },
  created() {
    document.onkeydown = e => {
      const key = e.keyCode;
      if (key === 13) {
        this.login();
      }
    };
  },
  mounted(){
    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
    document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
  }
};
</script>

<style lang="less" scoped>
.loginBG {
  background-size: cover;
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 660px;
  display: flex;
  justify-content: center;

  .logo {
    position: absolute;
    width: 90%;
    top: -130px;
    left: 15px;
  }

  /*整块内容*/

  .container_lining {
    width: 430px;
    height: 330px;
    position: absolute;
    top: 44.5%;
    left: 62%;
    background-color: #fafafa;
    .drag{
        position: absolute;
        background-color: #e8e8e8;
        width: 340px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        top: 200px;
        left: 60px;
    }
    .handler{
        width: 40px;
        height: 38px;
        border: 1px solid #ccc;
        cursor: move;
    }
    .handler_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
    }
    .handler_ok_bg{
        background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
    }
    .drag_bg{
        background-color: #7ac23c;
        height: 38px;
        width: 0px;
    }
    .drag_text{
        position: absolute;
        top: 0px;
        width: 100%;text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select:none;
        -ms-user-select:none;
    }
  }

  /*头部区域*/

  .titleTOP {
    margin: 40px 0 18px 60px;
    font-size: 20px;
    font-weight: bold;
    color: #111419;
    display: inline-block;
    letter-spacing: 2px;
  }

  /*帐号和密码*/

  .username,
  .pwd {
    width: 340px;
    height: 38px;
    border-radius: 4px;
    margin-bottom: 18px;
    box-sizing: border-box;
    padding: 0 20px 0 40px;
    border: 1px solid #dadada;
    background: #f9f9f9;
    color: #575757;
    font-size: 14px;
  }

  .divAccount {
    position: absolute;
    top: 78px;
    left: 60px;
  }

  .icon {
    position: absolute;
    width: 18px;
    height: 18px;
    background-size: cover;
    left: 13px;
    top: 10px;
    color: #575757;
  }

  .divMima {
    position: absolute;
    top: 134px;
    left: 60px;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #dadada;
    font-size: 14px;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-size: 14px;
    color: #dadada;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-size: 14px;
    color: #dadada;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    font-size: 14px;
    color: #dadada;
  }

  .btn {
    background: url(../src/assets/images/common/login.png) no-repeat;
    background-size: cover;
    cursor: pointer;
    position: absolute;
    /*display: inline-block;*/
    top: 265px;
    right: 60px;
    width: 100px;
    height: 38px;
    font-size: 14px;
    margin-top: 3px;
    margin-left: 300px;
    color: #fff;
    border-radius: 4px;
  }
}
</style>
